import { Button } from "@/components/ui/button";
import { Link } from "react-router-dom";
import { Helmet } from 'react-helmet-async';

const Index = () => {
  return (
    <div>
      <Helmet>
        <title>Dieticians Near Me In Johannesburg | Functional Foodie</title>
        <meta 
          name="description" 
          content="Find expert dieticians near you in Johannesburg. Functional Foodie offers personalised nutrition plans for a healthier lifestyle. Book your consultation today!"
        />
      </Helmet>
      {/* Hero Section */}
      <section className="relative h-screen bg-[url('https://images.unsplash.com/photo-1490818387583-1baba5e638af?q=80&w=1932&auto=format&fit=crop')] bg-cover bg-center">
        <div className="absolute inset-0 bg-black/40" />
        <div className="relative container mx-auto px-4 h-full flex flex-col items-center justify-center text-center pt-20">
          <h1 className="text-5xl md:text-6xl font-bold mb-6 text-white">
            Welcome to <span className="text-secondary">Functional Foodie</span> Registered Dietitians
          </h1>
          <p className="text-xl md:text-2xl mb-12 text-white max-w-3xl">
            Discover personalised nutrition solutions that transform your health and well-being with our expert registered dietitians.
          </p>
          <Link to="/contact">
            <Button 
              size="lg" 
              className="bg-secondary hover:bg-secondary-light text-secondary-foreground text-lg px-8 rounded-full"
            >
              CONTACT US
            </Button>
          </Link>
        </div>
      </section>

      {/* Booking CTA Section */}
      <section className="py-20 bg-white">
        <div className="container mx-auto px-4 text-center">
          <h2 className="text-2xl md:text-3xl text-primary max-w-4xl mx-auto mb-8">
            Take control of your health today! Book your appointment online to get personalised nutritional advice and start your journey to healthier you.
          </h2>
          <Link to="/booking">
            <Button size="lg" className="bg-primary hover:bg-primary-light text-white text-lg px-12 py-6 rounded-full">
              BOOK YOUR APPOINTMENT
            </Button>
          </Link>
        </div>
      </section>

      {/* Process Section */}
      <section className="py-20 bg-primary text-white">
        <div className="container mx-auto px-4">
          <h2 className="text-4xl md:text-5xl font-bold text-center mb-16">
            Our <span className="text-secondary">Process</span>
          </h2>
          
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8 md:gap-12">
            {/* Initial Consult */}
            <div className="space-y-4">
              <div className="rounded-3xl overflow-hidden">
                <img 
                  src="/lovable-uploads/6dbcc763-b40f-457c-922c-2231c52899cd.png" 
                  alt="Initial consultation with dietitian and fresh vegetables" 
                  className="w-full h-48 object-cover"
                />
              </div>
              <h3 className="text-2xl font-semibold">1. Initial Consult</h3>
              <p className="text-accent leading-relaxed">
                The initial consultation is where our journey begins. It is an assessment session where we consider your dietary history, preferences, relevant medical conditions, and overall eating habits. This information will help us create a tailor-made meal plan that should be both enjoyable and sustainable.
              </p>
            </div>

            {/* Meal Plan Collection */}
            <div className="space-y-4">
              <div className="rounded-3xl overflow-hidden">
                <img 
                  src="/lovable-uploads/13cb5415-22f5-4c82-bd6b-98636ecf3990.png" 
                  alt="Meal plan with fresh ingredients and clipboard" 
                  className="w-full h-48 object-cover"
                />
              </div>
              <h3 className="text-2xl font-semibold">2. Meal Plan Collection</h3>
              <p className="text-accent leading-relaxed">
                After your initial consultation, I will create a tailor-made meal plan for your individual needs. This session is where you will collect your meal plan and we will go through it together in detail and ensure that you are satisfied with the plan forward.
              </p>
            </div>

            {/* Follow Ups */}
            <div className="space-y-4">
              <div className="rounded-3xl overflow-hidden">
                <img 
                  src="/lovable-uploads/9d48fdc0-266b-45c0-b6ce-e157fa6e6eaa.png" 
                  alt="Healthy ingredients including avocado, grilled chicken, and fresh vegetables floating above a spoon" 
                  className="w-full h-48 object-cover"
                />
              </div>
              <h3 className="text-2xl font-semibold">3. Follow Ups</h3>
              <p className="text-accent leading-relaxed">
                Follow up consultations are extremely important to track your progress and make any changes that may be necessary. The continuous support and education is designed to assist you to keep on track.
              </p>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Index;
